/**
 * Universal Zoom Reset Handler
 * Detects zoom changes and resets page layout when zoom returns to normal
 * Works on all devices (iPhone, Android, Desktop)
 */

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    zoomThreshold: 0.05, // 5% threshold for zoom detection
    debounceDelay: 150, // Debounce delay for resize events
    resetDelay: 100 // Delay before resetting layout
  };
  
  // State variables
  let initialScale = 1;
  let currentScale = 1;
  let isZoomed = false;
  let debounceTimer = null;
  
  /**
   * Get current zoom/scale level
   * Uses multiple methods for better browser compatibility
   */
  function getCurrentZoomLevel() {
    // Method 1: Visual Viewport API (most accurate)
    if (window.visualViewport) {
      return window.visualViewport.scale;
    }
    
    // Method 2: Window dimensions comparison
    const devicePixelRatio = window.devicePixelRatio || 1;
    const screenWidth = window.screen.width;
    const windowWidth = window.innerWidth;
    
    // Calculate zoom based on viewport width
    const calculatedZoom = (screenWidth / windowWidth) / devicePixelRatio;
    
    return calculatedZoom;
  }
  
  /**
   * Check if page is currently zoomed
   */
  function isPageZoomed() {
    currentScale = getCurrentZoomLevel();
    return Math.abs(currentScale - initialScale) > CONFIG.zoomThreshold;
  }
  
  /**
   * Reset page layout and force reflow
   */
  function resetPageLayout() {
    console.log('🔄 Resetting page layout after zoom...');
    
    const body = document.body;
    const html = document.documentElement;
    
    // Force layout recalculation
    body.style.height = 'auto';
    html.style.height = 'auto';
    
    // Trigger reflow
    void body.offsetHeight;
    void html.offsetHeight;
    
    // Dispatch resize event to recalculate all responsive elements
    window.dispatchEvent(new Event('resize'));
    
    // Reset any transform-related issues
    const mainProduct = document.querySelector('.main-product');
    if (mainProduct) {
      const computed = window.getComputedStyle(mainProduct);
      if (computed.transform !== 'none') {
        mainProduct.style.transform = '';
        void mainProduct.offsetHeight; // Force reflow
      }
    }
    
    // Reset sticky elements
    const stickyElements = document.querySelectorAll('[class*="sticky"]');
    stickyElements.forEach(el => {
      const position = el.style.position;
      el.style.position = 'relative';
      void el.offsetHeight; // Force reflow
      el.style.position = position;
    });
    
    console.log('✅ Page layout reset complete');
  }
  
  /**
   * Handle zoom state changes
   */
  function handleZoomChange() {
    const zoomed = isPageZoomed();
    
    // Zoom state changed from zoomed to normal
    if (!zoomed && isZoomed) {
      console.log('📏 Zoom returned to normal, resetting layout...');
      isZoomed = false;
      
      // Reset layout after a brief delay
      setTimeout(() => {
        resetPageLayout();
      }, CONFIG.resetDelay);
    } 
    // Zoom state changed from normal to zoomed
    else if (zoomed && !isZoomed) {
      console.log('🔍 Page zoom detected');
      isZoomed = true;
    }
  }
  
  /**
   * Debounced resize handler
   */
  function handleResize() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      handleZoomChange();
    }, CONFIG.debounceDelay);
  }
  
  /**
   * Handle orientation change
   */
  function handleOrientationChange() {
    // Reset initial scale after orientation change
    setTimeout(() => {
      initialScale = getCurrentZoomLevel();
      isZoomed = false;
      console.log('📱 Orientation changed, reset zoom baseline');
    }, 300);
  }
  
  /**
   * Initialize the zoom reset handler
   */
  function init() {
    // Set initial scale
    initialScale = getCurrentZoomLevel();
    
    // Add event listeners
    window.addEventListener('resize', handleResize);
    
    // Visual Viewport API (best for zoom detection)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
      window.visualViewport.addEventListener('scroll', handleResize);
    }
    
    // Orientation change
    window.addEventListener('orientationchange', handleOrientationChange);
    
    // Handle page visibility changes (when returning to tab)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        handleZoomChange();
      }
    });
    
    console.log('✅ Zoom reset handler initialized');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();

